!function(){"use strict";
try{console.log("[WBB] wholesale-order-form v1.9-loose-variant loaded")}catch(t){}
if(document.getElementById("palletTbody")){
  var t=window.WBB_CATALOG||{};
  Object.keys(t).forEach(function(e){var n=t[e];n.items=[];n.groups.forEach(function(t){t.items.forEach(function(e){e.fallbackUrl="/products/"+t.productHandle+"?variant="+e.variantId;e.groupTitle=t.title;n.items.push(e)})})});
  var e=localStorage.getItem("bingltd_pack")||"standard",n=[],a={standard:{primary:"#efe36f",primaryDark:"#a88a13",bg:"#fbf6d8",textOnPrimary:"#3b3530",groupGradient:"linear-gradient(90deg,#efe36f 0%,#e6d24a 100%)",tierPriceColor:"#8a6f14"},upsable:{primary:"#667337",primaryDark:"#4c5628",bg:"#eef1e3",textOnPrimary:"#ffffff",groupGradient:"linear-gradient(90deg,#667337 0%,#4c5628 100%)",tierPriceColor:"#4c5628"}};
  document.querySelectorAll(".order-table").forEach(function(t){
    t.addEventListener("input",function(t){if(t.target.classList.contains("qty-input")||t.target.classList.contains("qty-input-loose"))p()});
    t.addEventListener("click",function(t){
      var e=t.target.closest("tr");
      if(e&&e.dataset.sku){
        if(t.target.classList.contains("qty-inc")){var n=e.querySelector(".qty-input");if(n){n.value=(parseInt(n.value)||0)+1;p()}}
        else if(t.target.classList.contains("qty-dec")){var n2=e.querySelector(".qty-input");if(n2){var a=parseInt(n2.value)||0;n2.value=Math.max(0,a-1);p()}}
        else if(t.target.classList.contains("qty-inc-loose")){var lp=e.querySelector(".qty-input-loose");if(lp){lp.value=(parseInt(lp.value)||0)+1;p()}}
        else if(t.target.classList.contains("qty-dec-loose")){var lp2=e.querySelector(".qty-input-loose");if(lp2){var av=parseInt(lp2.value)||0;lp2.value=Math.max(0,av-1);p()}}
      }
    })
  });
  var r=document.getElementById("submitBtn");
  r&&r.addEventListener("click",function(){
    if(0!==n.length){
      var t=document.getElementById("submitBtn");
      t.disabled=!0;
      var eLabel=t.textContent;
      t.textContent="Adding to cart…";
      var a=[];
      n.forEach(function(item){
        if(item.qty && item.qty>0){
          a.push({id:parseInt(item.variantId),quantity:item.qty*item.packSize,properties:{_Packing:s().label,"_Pallets ordered":item.qty+" pallet"+(item.qty>1?"s":""),"_Pieces per pallet":item.packSize,"_Wholesale tier":"1-10 Pallets","_Purchase type":"Pallet"}});
        }
        if(item.looseQty && item.looseQty>0){
          var lvid=item.looseVariantId||item.variantId;
          a.push({id:parseInt(lvid),quantity:item.looseQty,properties:{_Packing:s().label,"_Purchase type":"Loose piece"}});
        }
      });
      var r={"Wholesale order":"YES — via /pages/wholesale-butcher-block","Packing method":s().label,"Shipping method":s().shipMethod+" — freight quote required"};
      fetch("/cart/clear.js",{method:"POST",headers:{"Content-Type":"application/json"}}).then(function(){return fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:a})})}).then(function(t){if(!t.ok)throw new Error("Cart add failed: "+t.status);return t.json()}).then(function(){var t=Object.keys(r).map(function(t){return t+": "+r[t]});return fetch("/cart/update.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({note:t.join("\n"),attributes:r})})}).then(function(){window.location.href="/checkout"}).catch(function(n){console.error("Order submit error:",n);t.disabled=!1;t.textContent=eLabel||"Submit Order →";alert("Could not add to cart: "+n.message+" — please contact BingLTD directly.")})
    }else alert("No items in cart yet — add pallet or piece quantities first.")
  });
  c();
  (function(){
    var t=document.querySelectorAll(".pack-option");
    function hexToRgba(t,e){var n=t.replace("#","");3===n.length&&(n=n.split("").map(function(t){return t+t}).join(""));var a=parseInt(n.substr(0,2),16),r=parseInt(n.substr(2,2),16),o=parseInt(n.substr(4,2),16);return"rgba("+a+","+r+","+o+","+e+")"}
    function n(){
      t.forEach(function(t){
        var n=t.dataset.pack,a=o(n),r=n===e;
        t.style.borderColor=r?a.primary:"var(--wbb-line, #E5E5E5)";
        t.style.background=r?a.primary:a.bg;
        t.style.color=r?a.textOnPrimary:"inherit";
        t.style.boxShadow=r?"0 6px 16px "+hexToRgba(a.primary,.35)+", 0 0 0 2px "+a.primary+" inset":"none";
        t.style.transform=r?"scale(1.02)":"scale(1)";
        t.style.transition="all 0.2s ease";
        t.querySelectorAll("div, span, strong").forEach(function(t){t.style.color=r?a.textOnPrimary:""});
        var i=t.querySelector("input[type=radio]");
        i&&(i.checked=r,i.style.accentColor=a.primary)
      })
    }
    t.forEach(function(t){t.addEventListener("click",function(){var a=t.dataset.pack;a!==e&&(e=a,localStorage.setItem("bingltd_pack",a),n(),c())})});
    n()
  })()
}else try{console.warn("[WBB] #palletTbody missing — order table not rendered on this page")}catch(t){}

function o(t){return a[t]||a.standard}
function i(t){return"$"+t.toLocaleString("en-US",{minimumFractionDigits:2,maximumFractionDigits:2})}
function s(){return t[e]}
function isUpsableRow(){return e==="upsable"}
function getLivePrice(item){
  if(window.WBB_LIVE_PRICES && window.WBB_LIVE_PRICES[item.variantId] != null){
    var lp = Number(window.WBB_LIVE_PRICES[item.variantId]);
    if(!isNaN(lp)) return lp;
  }
  if(item.price != null && !isNaN(Number(item.price))) return Number(item.price);
  return null;
}
function getMsrp(item){
  return (typeof item.msrp === 'number' && item.msrp > 0) ? item.msrp : null;
}
function getLoosePrice(item){
  if(typeof item.loose_price==='number' && item.loose_price>0) return item.loose_price;
  if(typeof item.msrp==='number' && item.msrp>0) return item.msrp;
  return null;
}
function l(t){
  var n=s(),a=o(e),r=n.packSize;
  var price=getLivePrice(t);
  var hasPrice=(price!=null);
  var msrp=hasPrice?getMsrp(t):null;
  var savePct=(msrp && msrp>price)?Math.round(((msrp-price)/msrp)*100):0;
  var palletTotal=hasPrice?price*r:0;
  var d=window.WBB_PRODUCT_IMAGES&&window.WBB_PRODUCT_IMAGES[t.variantId]||t.img;
  var u=window.WBB_PRODUCT_URLS&&window.WBB_PRODUCT_URLS[t.variantId]||t.fallbackUrl;
  var upsable=isUpsableRow();
  var loosePrice=upsable?getLoosePrice(t):null;
  var hasLoose=(loosePrice!=null && loosePrice>0);
  if(!hasPrice){
    return `
      <tr data-sku="${t.sku}" data-pack-size="${r}" data-sqft="${t.sqFt}" data-price="" data-no-price="1">
        <td>
          <div class="product-cell">
            <img src="${d}" class="product-img" alt="" onerror="this.style.background='var(--cream)'">
            <div class="product-info">
              <h4><a href="${u}" target="_blank" rel="noopener" style="color:inherit;text-decoration:none;border-bottom:1px dashed rgba(0,0,0,.2);">${t.name} <span style="font-size:0.7em;opacity:.5;">↗</span></a></h4>
              <span class="sku">SKU · ${t.sku}</span>
            </div>
          </div>
        </td>
        <td><span class="qty-pack-badge" style="background:${a.bg};color:${a.primaryDark};border:1px solid ${a.primary};">${r} pcs/pallet</span></td>
        <td colspan="3" style="text-align:center;padding:14px 20px;background:#FEF2F2;border-left:3px solid #FECACA;">
          <a href="#requestQuoteForm" style="color:#B91C1C;font-weight:800;text-decoration:none;font-size:0.9rem;" onclick="return window.wbbScrollToQuote &amp;&amp; window.wbbScrollToQuote(event)">
            <span style="text-decoration:underline;">Contact for pricing →</span>
          </a>
          <div style="font-size:0.68rem;color:#7f1d1d;margin-top:4px;font-weight:600;">Pricing unavailable — request custom quote</div>
        </td>
      </tr>`;
  }
  var pricingCell='<div style="display:flex;flex-direction:column;align-items:center;gap:3px;">';
  if(upsable && hasLoose){
    pricingCell+='<span style="font-size:0.68rem;font-weight:700;color:#666;text-transform:uppercase;letter-spacing:0.03em;">Pallet (10 pcs)</span>';
    pricingCell+='<span class="primary" style="color:'+a.tierPriceColor+';">'+i(price)+'/pc</span>';
    pricingCell+='<span class="secondary" style="font-size:0.72rem;color:var(--wbb-wood-dark);font-weight:700;">'+i(palletTotal)+'/pallet</span>';
    pricingCell+='<div style="height:1px;background:#ddd;width:80%;margin:4px 0;"></div>';
    pricingCell+='<span style="font-size:0.68rem;font-weight:700;color:#B47D0F;text-transform:uppercase;letter-spacing:0.03em;">Loose (1 pc)</span>';
    pricingCell+='<span style="color:#B47D0F;font-weight:800;font-size:0.95rem;">'+i(loosePrice)+'/pc</span>';
  } else {
    var msrpRow = (msrp && msrp>price)
      ? '<div style="display:flex;align-items:center;justify-content:center;gap:6px;line-height:1;flex-wrap:wrap;"><span style="text-decoration:line-through;color:#888;font-size:0.85em;">'+i(msrp)+'</span>'+(savePct>0?'<span style="background:#efe36f;color:#3b3530;padding:2px 8px;border-radius:4px;font-size:0.75em;font-weight:800;">SAVE '+savePct+'%</span>':'')+'</div>'
      : '';
    pricingCell+=msrpRow;
    pricingCell+='<span class="primary" style="color:'+a.tierPriceColor+';">'+i(price)+'/pc</span>';
    pricingCell+='<span class="secondary" style="font-size:0.75rem;color:var(--wbb-wood-dark);font-weight:700;">'+i(palletTotal)+'/pallet</span>';
  }
  pricingCell+='</div>';

  var qtyCell='<div class="qty-input-group"><button type="button" class="qty-dec">−</button><input type="number" class="qty-input" value="0" min="0"><button type="button" class="qty-inc">+</button></div><span class="qty-unit">pallets</span>';
  if(upsable && hasLoose){
    qtyCell+='<div style="height:8px;"></div>';
    qtyCell+='<div class="qty-input-group qty-input-group-loose" style="border-top:1px dashed #B47D0F;padding-top:8px;margin-top:4px;"><button type="button" class="qty-dec-loose">−</button><input type="number" class="qty-input-loose" value="0" min="0" style="border-color:#B47D0F;"><button type="button" class="qty-inc-loose">+</button></div><span class="qty-unit" style="color:#B47D0F;">loose pcs</span>';
  }
  qtyCell+='<span class="stock-hint" data-variant-id="'+t.variantId+'"></span>';

  return `
      <tr data-sku="${t.sku}" data-pack-size="${r}" data-sqft="${t.sqFt}" data-price="${price}" data-loose-price="${loosePrice||''}" data-upsable="${upsable?'1':'0'}">
        <td>
          <div class="product-cell">
            <img src="${d}" class="product-img" alt="" onerror="this.style.background='var(--cream)'">
            <div class="product-info">
              <h4><a href="${u}" target="_blank" rel="noopener" style="color:inherit;text-decoration:none;border-bottom:1px dashed rgba(0,0,0,.2);">${t.name} <span style="font-size:0.7em;opacity:.5;">↗</span></a></h4>
              <span class="sku">SKU · ${t.sku}</span>
            </div>
          </div>
        </td>
        <td><span class="qty-pack-badge" style="background:${a.bg};color:${a.primaryDark};border:1px solid ${a.primary};">${r} pcs/pallet</span></td>
        <td class="tier-price tier-active" data-tier="1">${pricingCell}</td>
        <td class="qty-cell">${qtyCell}</td>
        <td class="calc-cell">
          <span class="total-pcs">— pieces</span>
          <span class="total-price">$0.00</span>
        </td>
      </tr>`;
}
function c(){
  var t=s(),n=o(e),a="";
  var upsable=isUpsableRow();
  if(upsable){
    a+='<tr class="wbb-info-row"><td colspan="5" style="background:#FDF6E3;color:#8a6b1a;padding:10px 20px;font-size:0.82rem;border-left:3px solid #B47D0F;"><strong>UPSable Packaging:</strong> You may order by full pallet (10 pcs, best price) <em>or</em> add individual loose pieces at the loose-piece rate. Both options ship together.</td></tr>';
  } else {
    a+='<tr class="wbb-info-row"><td colspan="5" style="background:#FDF6E3;color:#8a6b1a;padding:10px 20px;font-size:0.82rem;border-left:3px solid #B47D0F;"><strong>Standard Packaging (16 pcs/pallet):</strong> Sold by full pallet only. For loose-piece orders, switch to UPSable Packaging above.</td></tr>';
  }
  t.groups.forEach(function(t){a+=`<tr class="group-header"><td colspan="5" style="background:${n.groupGradient};color:${n.textOnPrimary};padding:12px 20px;font-weight:800;font-size:0.95rem;letter-spacing:0.05em;text-transform:uppercase;">${t.title} <span style="font-size:0.7rem;font-weight:500;opacity:0.75;margin-left:10px;">${t.items.length} sizes</span></td></tr>`;a+=t.items.map(l).join("")});
  document.getElementById("palletTbody").innerHTML=a;
  var r=document.getElementById("packLabel");r&&(r.textContent=t.tagline);
  var i2=document.getElementById("packSizeLabel");i2&&(i2.textContent=upsable?"Order by pallet ("+t.packSize+" pcs) or by loose piece":"Order by pallet ("+t.packSize+" pcs/pallet)");
  var c2=document.getElementById("shipMethodLabel");c2&&(c2.textContent=t.shipMethod);
  var d2=document.getElementById("submitBtn");d2&&(d2.style.background=n.primary,d2.style.borderColor=n.primary,d2.style.color=n.textOnPrimary);
  var u2=document.getElementById("requestQuoteBtn");u2&&(u2.style.color=n.primaryDark,u2.style.borderColor=n.primary);
  p()
}
function d(t){var e=window.WBB_INVENTORY_MAP;if(!e)return null;var n=e[t];return n?n.managed&&"continue"!==n.policy?{qty:Math.max(0,n.qty||0),unlimited:!1}:{qty:1/0,unlimited:!0}:null}
function u(t){
  if(t.dataset.noPrice==="1") return null;
  var sku=t.dataset.sku,packSize=parseInt(t.dataset.packSize),sqft=parseFloat(t.dataset.sqft),palletPrice=parseFloat(t.dataset.price);
  var loosePriceAttr=t.dataset.loosePrice;
  var loosePrice=loosePriceAttr?parseFloat(loosePriceAttr):null;
  var upsable=t.dataset.upsable==="1";
  var qi=t.querySelector(".qty-input");var palletQty=qi?(parseInt(qi.value)||0):0;
  var li=t.querySelector(".qty-input-loose");var looseQty=li?(parseInt(li.value)||0):0;
  var item=s().items.find(function(x){return x.sku===sku});
  if(!item)return null;
  var totalPieces=palletQty*packSize;
  var totalPiecesForStock=totalPieces+looseQty;
  var totalSqFt=totalPiecesForStock*sqft;
  var pB=palletQty>=11;
  var m=d(item.variantId),y=m&&!m.unlimited&&totalPiecesForStock>m.qty;
  var palletSubtotal=(pB||y)?0:totalPieces*palletPrice;
  var looseSubtotal=(y||!loosePrice)?0:looseQty*(loosePrice||0);
  var totalPrice=palletSubtotal+looseSubtotal;
  var v=t.querySelector(".calc-cell"),b=v?v.querySelector(".total-pcs"):null,g=v?v.querySelector(".total-price"):null;
  (function(t,e){var n=t.querySelector(".stock-hint");if(n){var a=d(e.variantId);if(!a||a.unlimited){n.textContent="";n.className="stock-hint";return}if(0===a.qty){n.textContent="Out of stock";n.className="stock-hint out";return}if(a.qty<20){n.textContent="In stock: "+a.qty+" pcs";n.className="stock-hint low";return}n.textContent="In stock: "+a.qty+" pcs";n.className="stock-hint"}})(t,item);
  if(!v||!b||!g){}
  else if(0===palletQty && 0===looseQty){b.textContent="— pieces";g.textContent="$0.00";v.classList.remove("has-value","bulk-lock");t.classList.remove("has-qty","bulk-lock")}
  else if(y){b.textContent=totalPiecesForStock+" pcs needed";g.innerHTML='<a href="#requestQuoteForm" style="font-size:0.68rem;color:#B91C1C;font-weight:700;text-decoration:none;display:block;line-height:1.4;padding:6px 8px;background:#FEE2E2;border-radius:6px;border:1px solid #FECACA;" onclick="return window.wbbScrollToQuote &amp;&amp; window.wbbScrollToQuote(event)">⚠ <strong>Insufficient Stock.</strong><br>Only '+m.qty+' pcs available.<br><span style="text-decoration:underline;">Contact Sales Team →</span></a>';v.classList.add("has-value","bulk-lock");t.classList.add("has-value","bulk-lock")}
  else if(pB){b.textContent=totalPiecesForStock+" pcs";g.innerHTML='<a href="#requestQuoteForm" style="font-size:0.7rem;color:var(--red);font-weight:700;text-decoration:underline;" onclick="return window.wbbScrollToQuote &amp;&amp; window.wbbScrollToQuote(event)">Request Quote →</a>';v.classList.add("has-value","bulk-lock");t.classList.add("has-qty","bulk-lock")}
  else{
    var parts=[];
    if(palletQty>0) parts.push(totalPieces+' pallet-pcs');
    if(looseQty>0) parts.push(looseQty+' loose');
    b.textContent=parts.join(' + ');
    g.innerHTML=i(totalPrice);
    v.classList.add("has-value");v.classList.remove("bulk-lock");t.classList.add("has-qty");t.classList.remove("bulk-lock")
  }
  return{sku:sku,name:item.name,qty:palletQty,looseQty:looseQty,packSize:packSize,totalPieces:totalPieces,looseTotal:looseSubtotal,palletTotal:palletSubtotal,totalSqFt:totalSqFt,pricePerPiece:pB||y?null:palletPrice,loosePrice:loosePrice,totalPrice:totalPrice,isBulk:pB,overStock:y,availableStock:m&&!m.unlimited?m.qty:null,variantId:item.variantId,looseVariantId:item.loose_variant_id||null}
}
function p(){
  n.length=0;
  document.querySelectorAll(".order-table tbody tr[data-sku]").forEach(function(t){var e=u(t);if(e && (e.qty>0 || e.looseQty>0)) n.push(e)});
  (function(){
    var t=document.getElementById("summaryContent"),e=document.getElementById("submitBtn");
    if(!t||!e)return;
    if(0===n.length){t.innerHTML='<div class="summary-empty"><div class="icon">🛒</div><div>No items yet</div><div style="font-size:0.75rem;margin-top:6px;">Add pallet quantities or loose pieces to see your order</div></div>';e.disabled=!0;return}
    var totalPallets=n.reduce(function(t,e){return t+e.qty},0);
    var totalLoose=n.reduce(function(t,e){return t+e.looseQty},0);
    var totalPcs=n.reduce(function(t,e){return t+e.totalPieces+e.looseQty},0);
    var totalMoney=n.reduce(function(t,e){return t+e.totalPrice},0);
    var s=n.some(function(t){return t.isBulk});
    var l=n.some(function(t){return t.overStock});
    var c=s||l;
    var d='<div class="summary-items">';
    n.forEach(function(it){
      var badge="",priceStr;
      if(it.overStock){badge=' <span style="background:#FEE2E2;color:#B91C1C;padding:1px 6px;border-radius:3px;font-size:0.6rem;font-weight:700;">LOW STOCK</span>';priceStr='<span style="color:#B91C1C;font-size:0.7rem;font-weight:700;">Only '+it.availableStock+' pcs · Contact Sales</span>'}
      else if(it.isBulk){badge=' <span style="background:#FEE2E2;color:var(--red);padding:1px 6px;border-radius:3px;font-size:0.6rem;font-weight:700;">BULK</span>';priceStr='<span style="color:var(--red);font-size:0.7rem;font-weight:700;">Quote required</span>'}
      else{priceStr=i(it.totalPrice)}
      var qtyParts=[];
      if(it.qty>0) qtyParts.push(it.qty+' pallet'+(it.qty>1?'s':'')+' ('+it.totalPieces+' pcs)');
      if(it.looseQty>0) qtyParts.push(it.looseQty+' loose pc'+(it.looseQty>1?'s':''));
      d+='<div class="summary-item"><div class="info"><div class="name">'+it.sku+badge+'</div><div class="qty">'+qtyParts.join(' + ')+'</div></div><div class="price">'+priceStr+'</div></div>';
    });
    d+="</div>";
    var subtotalStr=c?'<span style="color:var(--red);font-size:0.9rem;">Quote required</span>':i(totalMoney);
    d+='<div class="summary-totals">';
    d+='<div class="summary-row"><span>Total pallets</span><span>'+totalPallets.toLocaleString()+'</span></div>';
    if(totalLoose>0) d+='<div class="summary-row"><span>Total loose pcs</span><span>'+totalLoose.toLocaleString()+'</span></div>';
    d+='<div class="summary-row"><span>Total pieces</span><span>'+totalPcs.toLocaleString()+'</span></div>';
    d+='<div class="summary-row grand"><span>Subtotal (pickup)</span><span>'+subtotalStr+'</span></div>';
    d+='</div>';
    if(l)d+='<div style="margin-top:12px;padding:12px;background:#FEF2F2;border:1px solid #FECACA;border-radius:8px;font-size:0.78rem;color:#991B1B;line-height:1.5;"><strong>⚠ Insufficient Stock.</strong><br>Please adjust your quantity or <a href="#requestQuoteForm" style="color:#991B1B;font-weight:800;text-decoration:underline;" onclick="return window.wbbScrollToQuote &amp;&amp; window.wbbScrollToQuote(event)">contact our Sales Team →</a> for assistance.</div>';
    else if(s)d+='<div style="margin-top:12px;padding:12px;background:#FEF2F2;border:1px solid #FECACA;border-radius:8px;font-size:0.78rem;color:#991B1B;line-height:1.5;"><strong>⚡ Bulk order detected (≥11 pallets).</strong><br>Custom pricing available — <a href="#requestQuoteForm" style="color:#991B1B;font-weight:800;text-decoration:underline;">Request a custom quote →</a></div>';
    d+='<div class="wbb-summary-ship"><strong>📦 Shipping is not included.</strong>A shipping quote will be provided after order submission based on packaging, quantity, and destination.</div>';
    t.innerHTML=d;
    e.disabled=c;
    e.style.opacity=c?"0.35":"1";
    e.style.cursor=c?"not-allowed":"pointer"
  })()
}
}();
